import {postNullify} from '../api/postNullify';

const setPostNullify = (params) => {
    return async (dispatch, getState) => {
        try {
            await postNullify(params);     
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostNullify
}